module.exports = __webpack_public_path__ + "img/shuju.1a3e7ace.png";